"use strict";

exports.__esModule = true;
exports["default"] = {
  handleClick: function handleClick(e) {
    e.stopPropagation();
  }
};
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-devtools-log-monitor/~/react-json-tree/lib/mixins/squash-click-event.js
 ** module id = 355
 ** module chunks = 0
 **/